import templateUrl from "./user-list.html";
import { forEach } from "angular";

export const userListComponent = {
  bindings: {
    userListData: "<",
    statusList: "<",
  },
  templateUrl,
  controller: class UserListComponent {
    constructor(
      $state,
      toastr,
      $scope,
      $cookies,
      $stateParams,
      $window,
      ApiService,
      AuthService,
      UserService,
      ModalService,
      DateService
    ) {
      "ngInject";

      this.modal;
      this.$state = $state;
      this.$scope = $scope;
      this.toastr = toastr;
      this.$cookies = $cookies;
      this.$stateParams = $stateParams;
      this.$window = $window;
      this.authService = AuthService;
      this.userService = UserService;
      this.modalService = ModalService;
      this.apiService = ApiService;
      this.dateService = DateService;
    }

    $onInit() {
      this.user = this.authService.getUser();
      this.isCommandCounselor = this.user.role === "commandCareerCounselor";
      this.userListData = this._getUserListObject(this.userListData);
      this.source = this.$stateParams.source;
      this.showUserTypeList = false;
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.totalItems = this.userListData.listView.totalCount || 0;
      this.isFiltered = false;
      this.rolesName = [];
      this.dowonLoadUrl;
      this.mobileDeviceResolution = window.innerWidth < 992 ? true : false;
      if (this.mobileDeviceResolution) {
        this.listView = true;
        this.tableView = false;
      } else {
        this.listView = false;
        this.tableView = true;
      }

      this.isEmpty =
        this.userListData &&
        this.userListData.listView.userList &&
        this.userListData.listView.userList.length === 0
          ? true
          : false;
      this.userListFilterObject = this.userService.getUserListFilterObject();
      this.userListSelectedFilterObject = {
        sortBy: null,
        status: "",
        timeline: "",
        limit: this.itemPerPage,
        pageId: this.currentPage,
        timelineIds: [],
        searchKeyword: "",
      };
      if (this.source) {
        this.userListSelectedFilterObject.source = this.source;
      }
      this.selectedTimelineFilter = "self";
      this.listViewData = this._getModifiedUserListData(
        this.userListData.listView.userList
      );
      this.tabularViewData = {
        config: this.userListData.tabularView.config,
        data: this._getModifiedUserListData(this.userListData.tabularView.data),
      };
      this.modifiedStatusList = angular.copy(
        this.statusList.filter(
          ({ isSpouseChecklist }) => isSpouseChecklist === false
        )
      );
      this.spouseChecklist = angular.copy(
        this.statusList.filter(
          ({ isSpouseChecklist }) => isSpouseChecklist === true
        )
      );

      this.statusRadioButtonList = this.getRadioButtonListByTitle("Status");
      this.timelineRadioButtonList = this.getRadioButtonListByTitle("Timeline");

      this.multilevelCheckboxList = this.userListFilterObject.find(
        (value) => value.type === "multilevelCheckbox" && value.key === "Stages"
      );
      if (this.multilevelCheckboxList) {
        this.multilevelCheckboxList.data = angular.copy(
          this.modifiedStatusList
        );
      }
      this.perferredLocationCheckboxList = this.userListFilterObject.find(
        (value) =>
          value.type === "multilevelCheckbox" &&
          value.key === "preferredlocation"
      );
      if (this.perferredLocationCheckboxList) {
        this.perferredLocationCheckboxList.data =
          this.userListData.filters.preferredLocations;
      }

      const referredSourcesList = this.userListFilterObject.find(
        (value) => value.key === "source"
      );
      if (referredSourcesList) {
        referredSourcesList.data =
          this.userListData.filters.referredSourcesList;
      }
    }
    onSearchMembers(value) {
      if (value === "") {
        this.currentPage = 1;
        this.userListSelectedFilterObject.searchKeyword = "";
        this.userListSelectedFilterObject.pageId = this.currentPage;
      } else {
        this.userListSelectedFilterObject.searchKeyword = value;
      }
      return this.getUserList({ searchKeyword: value });
    }
    exportToExcel() {
      let queryParams = [];
      const token = this.$cookies.get("token");
      let url = `/account/veterans/export?token=${token}`;
    //   const obj = this.userService._setUserListFilterObject(
    //     this.userListSelectedFilterObject
    //   );
    //  forEach(obj, function (value, key) {
    //     if (obj[key] && key !== "limit" && key !== "pageId") {
    //       if (obj[key] instanceof Array) {
    //         const arrayParams = obj[key].map((value) => {
    //           return `${key}[]=${encodeURIComponent(value)}`;
    //         });
    //         queryParams = queryParams.concat(arrayParams);
    //       }
    //       queryParams.push(`${key}=${encodeURIComponent(obj[key])}`);
    //     }
    //   });
    //   if (queryParams.length > 0) {
    //     queryParams = queryParams.join("&");
    //     url = `${url}&${queryParams}`;
    //   }
      const resourceUrl = this.apiService.getResourceUrl(url);
      window.open(resourceUrl, "_blank");
    }
    _getUserListObject(userListData) {
      //testing
      const filters = userListData.filters;
      if (filters && filters.preferredLocations) {
        filters.preferredLocations = filters.preferredLocations.map((value) => {
          return {
            id: value.veteranPreferredLocationMappingId,
            name: value.name,
          };
        });
      }
      if (filters && filters.referredSourcesList) {
        filters.referredSourcesList = filters.referredSourcesList.map(
          (value) => {
            return {
              id: value.referredSourceId,
              name: value.displayName,
            };
          }
        );
      }
      return {
        listView: {
          totalCount: userListData.totalCount,
          userList: userListData.userList.map((user) =>
            this._getUserObject(user)
          ),
        },
        tabularView: this._getTabularUserListDetails(userListData),
        filters,
      };
    }
    _getTabularUserListDetails(list) {
      let dataList = list.userList.map((data, index) => {
        (data.id = index + 1),
          (data.isLoctionOpen = false),
          (data.isOpen = false),
          (data.profileUuid = data.profileUuid),
          (data.profilePicUrl =
            data.profileUuid !== null
              ? this.apiService.getImageUrl(`${data.profileUuid}`)
              : "");
        return data;
      });
      let tabularUserList = {
        data: dataList,
        feature: "Users",
        config: {
          defaultColumn: {
            columnName: "sortOrder", //default column name
            order: "ASC", //ASC = Ascending , DES = Descending, DEF = Default
          },
          columnDefs: [
            {
              field: "careerCounselor",
              displayName: "TRANSITION MANAGER",
              rowClass: "underline-field text-capitalize",
              className: "col-lg-2 col-md-2",
            },
            {
              field: "name",
              displayName: "MEMBER's NAME",
              rowClass: "underline-field text-capitalize",
              className: "col-lg-2 col-md-2",
            },
            {
              field: "email",
              displayName: "EMAIL",
              className: "col-lg-4 col-md-5 text-break",
            },
            {
              type: "date",
              field: "eosDate",
              format: "MM/dd/yyyy",
              displayName: "EAOS DATE",
              className: "col-lg-2 col-md-2",
            },
            {
              field: "status",
              displayName: "STATUS",
              className: "col-lg-1 col-md-1 text-break text-capitalize",
            },
            {
              type: "multipleLocation",
              field: "preferredLocation",
              displayName: "PREFERRED LOCATIONS",
              className: "col-lg-2 col-md-2",
            },
            // {
            //   type: "array",
            //   field: "steps",
            //   displayName: "STAGES",
            //   className: "col-lg-3 col-md-2",
            // },
          ],
        },
      };
      if (this.isCommandCounselor) {
        tabularUserList.config.columnDefs.push({
          type: "Edit",
          field: "edit",
          enableSort: false,
        });
      }
      if (!this.isCommandCounselor) {
      tabularUserList.config.columnDefs.push({
        type: "Delete",
        field: "delete",
        enableSort: false,
      });
    }
      return tabularUserList;
    }
    _getUserObject({
      name,
      email,
      isView,
      steps,
      eosDate,
      careerCounselor,
      accountId,
      profileUuid,
      status,
      preferredLocation,
      remainingActiveDaysOfService,
      source,
    }) {
      return {
        accountId,
        email,
        isView,
        status,
        steps,
        eosDate,
        careerCounselor,
        name,
        locationList:
          preferredLocation && preferredLocation.length > 0
            ? preferredLocation.join(", ")
            : "  -",
        profileUuid,
        preferredLocation,
        profilePicUrl: profileUuid
          ? this.apiService.getImageUrl(`${profileUuid}`)
          : "",
        remainingActiveDaysOfService,
        source,
      };
    }
    _getModifiedUserListData(list) {
      list.reduce((accum, value, index) => {
        let userListStepsList = value.steps.filter(
          ({ isSpouseChecklist }) => isSpouseChecklist === false
        );
        let userListSpouseChecklist = value.steps.filter(
          ({ isSpouseChecklist }) => isSpouseChecklist === true
        );
        value.steps =
          this.selectedTimelineFilter === "self"
            ? userListStepsList
            : userListSpouseChecklist;
        accum.push(value);
        return accum;
      }, []);
      return list;
    }
    getRadioButtonListByTitle(selectedTitle) {
      return this.userListFilterObject.find(
        ({ type, title }) => type === "radio" && title === selectedTitle
      );
    }
    backdropClick(event) {
      if (
        !event.target.classList.contains("ignore-backdrop") &&
        this.tableView
      ) {
        this.userListFilterObject = this.userListFilterObject.map((details) => {
          if (
            details.title.toLowerCase() !== event.target.innerText.toLowerCase()
          ) {
            details.isOpen = false;
          }
          return details;
        });
        if (this.statusRadioButtonList) {
          this.statusRadioButtonList.isOpen = false;
        }
        this.$scope.$broadcast("backDropClick");
      }
    }
    _getDefaultRadioButtonValue(selectedValue, list) {
      return list.data.reduce((accum, value, index) => {
        if (value.name === selectedValue) {
          accum = value.id.toString();
        }
        return accum;
      }, "1");
    }
    onChangePage(pageNumber) {
      this.currentPage = pageNumber;
      this.userListSelectedFilterObject.pageId = this.currentPage;
      this.getUserList(this.userListSelectedFilterObject);
    }
    onLayoutChange(layout) {
      this.tableView = layout === "table" ? true : false;
      this.listView = layout === "list" ? true : false;
      if (this.tableView) {
        if (this.statusRadioButtonList) {
          this.statusRadioButtonList.isOpen = false;
        }
        if (this.multilevelCheckboxList) {
          this.multilevelCheckboxList.isOpen = false;
        }
      }
      // this.currentPage = 1;
      // this.userListSelectedFilterObject.limit = this.itemPerPage;
      // this.userListSelectedFilterObject.pageId = this.currentPage;
      // this.userListSelectedFilterObject.sortBy = null;
      if (this.listView) {
        this.userListFilterObject = this.userListFilterObject.map((data) => {
          data.isOpen = true;
          return data;
        });
      }
      // this.getUserList(this.userListSelectedFilterObject);
    }
    onChangeFilterData(details, currentObj) {
      this.userListSelectedFilterObject.pageId = 1;
      this.currentPage = 1;
      if (
        currentObj.key === "Timeline" &&
        currentObj.data !== this.userListSelectedFilterObject.timeline
      ) {
        // if user switches the timeline from self to spouse checklist and vice versa, reset the selected stage ids/timeline ids
        this.userListSelectedFilterObject.timelineIds = [];
        const stagesFilterIndex = this.userListFilterObject.findIndex(
          (filter) => filter.key === "Stages"
        );
        if (stagesFilterIndex > 0) {
          this.userListFilterObject[stagesFilterIndex].data = angular.copy(
            currentObj.data === "self"
              ? this.modifiedStatusList
              : this.spouseChecklist
          );
        }
      }

      // on click status filter
      if (currentObj.key === "Status") {
        this.userListSelectedFilterObject.status =
          currentObj.data.toLowerCase() !== "all" ? currentObj.data : null;
      }

      if (currentObj.key === "Timeline") {
        this.selectedTimelineFilter = currentObj.data;
        this.userListSelectedFilterObject.timeline = currentObj.data;
      }
      // on click stages filter
      if (currentObj.key === "Stages" && currentObj.data.parent.isSelected) {
        currentObj.data.selectedParentItems.map((id) => {
          // const userTypeObject = this.userService.getUserTypeObjectById(id);
          if (
            this.userListSelectedFilterObject.timelineIds.indexOf(id) === -1
          ) {
            this.userListSelectedFilterObject.timelineIds.push(id);
          }
        });
      } else if (currentObj.key === "Stages") {
        if (currentObj.data.selectedParentItems) {
          this.userListSelectedFilterObject.timelineIds =
            currentObj.data.selectedParentItems;
        }
      }

      if (currentObj.key === "preferredlocation") {
        this.userListSelectedFilterObject.preferredLocation =
          currentObj.data.selectedParentItems.length > 0
            ? currentObj.data.selectedParentItems.map((id) => {
                let selectedLocation =
                  this.userListData.filters.preferredLocations.find((data) => {
                    if (data.id === id) {
                      return data;
                    }
                  });
                return selectedLocation.name;
              })
            : null;
      }

      if (currentObj.key === "source") {
        this.userListSelectedFilterObject.referredSources =
          currentObj.data.selectedParentItems;
      }

      this.getUserList(this.userListSelectedFilterObject);
    }
    onChangeSort(fieldName) {
      if (fieldName === "eosDate") {
        fieldName = "eaos_date";
      }
      this.currentPage = 1;
      this.userListSelectedFilterObject.pageId = this.currentPage;
      const selectedSortBy = this.userListSelectedFilterObject.sortBy;
      if (fieldName) {
        if (selectedSortBy) {
          this.userListSelectedFilterObject.sortBy =
            selectedSortBy === `${fieldName}_asc`
              ? `${fieldName}_desc`
              : `${fieldName}_asc`;
        } else {
          this.userListSelectedFilterObject.sortBy = `${fieldName}_asc`;
        }
      }
      this.getUserList(this.userListSelectedFilterObject);
    }
    getUserList(params) {
      this.userService.getUserList(params).then((userListData) => {
        userListData = this._getUserListObject(userListData);
        this.userListData = angular.copy(userListData);
        this.listViewData = this._getModifiedUserListData(
          this.userListData.listView.userList
        );
        this.tabularViewData = {
          config: this.userListData.tabularView.config,
          data: this._getModifiedUserListData(
            this.userListData.tabularView.data
          ),
        };

        if (
          this.userListData.listView.totalCount ||
          this.userListData.listView.totalCount === 0
        ) {
          this.totalItems = this.userListData.listView.totalCount;
        }
        this.isEmpty =
          this.userListData.listView.userList.length === 0 ? true : false;
        this.isFiltered = true;
      });
    }
    onEdit({ accountId }) {
      this.$state.go("userEdit", { id: accountId });
    }
    onDelete({ accountId }) {
      this.modalService.open({
        details: {
          bodyMessage: "Are you sure you want to delete this user?",
        },
        buttons: [
          {
            name: "No",
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _delete.bind(this),
          },
        ],
      });
      function _delete() {
        this.userService.deleteMember(accountId).then(
          () => {
            this.toastr.success("User deleted successfully");
            this.$state.reload("user");
          },
          (errorDetails) => {
            this.toastr.success(errorDetails);
          }
        );
      }
    }
    onColumnClick({ accountId, careerCounselorId }, fieldName) {
      if (fieldName === "careerCounselor") {
        this.$state.go("profileDetail", {
          id: careerCounselorId,
        });
      } else {
        this.$state.go("userDetail", {
          id: accountId,
        });
      }
    }
    redirectToMemberProfile(id) {
      this.$state.go("userDetail", {
        id,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/user/user-list/user-list.component.js